import {
  Settings6,
  DoclingOCRProviderEngine,
  LLMApiType,
  OCRProviderModel,
  OCRProviderSettingsType,
} from '../../../../../gamma-api';

export const MAIN_CLASS_NAME = 'ocr-provider-modal';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const FORM_ITEM_CLASS_NAME = `${CONTENT_CLASS_NAME}__form-item`;

export const EASY_OCR_EXTRA_PARAMS_EN = {
  ocr_lang: ['en'],
};

export const EASY_OCR_EXTRA_PARAMS_RU = {
  ocr_lang: ['ru', 'en'],
};

export const RAPID_OCR_EXTRA_PARAMS_EN = {
  ocr_lang: ['latin'],
};

export const RAPID_OCR_EXTRA_PARAMS_RU = {
  ocr_lang: ['cyrillic', 'latin'],
};

export const TESSERACT_EXTRA_PARAMS_EN = {
  ocr_lang: ['eng'],
};

export const TESSERACT_EXTRA_PARAMS_RU = {
  ocr_lang: ['rus', 'eng'],
};

export const EMPTY_VLM_OCR_SETTINGS: Settings6 = {
  type: OCRProviderSettingsType.Vlm,
  images_mode: null,
  vlm_settings: {},
  api_type: LLMApiType.ChatCompletions,
  default_prompt: '',
  allow_prompt_override: false,
};

export const EMPTY_DOCLING_OCR_SETTINGS: Settings6 = {
  type: OCRProviderSettingsType.Docling,
  images_mode: null,
  base_url: '',
  ocr_engine: DoclingOCRProviderEngine.Tesseract,
  extra_params: {},
};

export const EMPTY_DOCLING_OCR_SETTINGS_EN: Settings6 = {
  ...EMPTY_DOCLING_OCR_SETTINGS,
  extra_params: TESSERACT_EXTRA_PARAMS_EN,
};

export const EMPTY_DOCLING_OCR_SETTINGS_RU: Settings6 = {
  ...EMPTY_DOCLING_OCR_SETTINGS,
  extra_params: TESSERACT_EXTRA_PARAMS_RU,
};

export const EMPTY_VLM_OCR_PROVIDER: OCRProviderModel = {
  ocr_provider_id: '',
  name: '',
  settings: EMPTY_VLM_OCR_SETTINGS,
};

export const EMPTY_DOCLING_OCR_PROVIDER: OCRProviderModel = {
  ocr_provider_id: '',
  name: '',
  settings: EMPTY_DOCLING_OCR_SETTINGS,
};

export const EMPTY_DOCLING_OCR_PROVIDER_EN: OCRProviderModel = {
  ...EMPTY_DOCLING_OCR_PROVIDER,
  settings: EMPTY_DOCLING_OCR_SETTINGS_EN,
};

export const EMPTY_DOCLING_OCR_PROVIDER_RU: OCRProviderModel = {
  ...EMPTY_DOCLING_OCR_PROVIDER,
  settings: EMPTY_DOCLING_OCR_SETTINGS_RU,
};

export const DEFAULT_OCR_PROVIDER = EMPTY_VLM_OCR_PROVIDER;

export const DOCLING_SERVER_BASE_URL = 'http://localhost:5001/';
export const DOCLING_SERVER_DOCS_PATH = 'docs#tag/convert/operation/process_file_v1_convert_file_post';
export const DOCLING_REFERENCE_DOC_URL = 'https://docling-project.github.io/docling/reference/pipeline_options/';
